import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FlareFileTextEditorGutterComponent } from './flare-file-text-editor-gutter.component';

@NgModule({
  declarations: [
    FlareFileTextEditorGutterComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatTooltipModule,
    MatButtonModule,
    MatIconModule
  ],
  exports: [
    FlareFileTextEditorGutterComponent
  ]
})
export class FlareFileTextEditorGutterModule { }
